import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { CLQuantitySelector } from "./CLQuantitySelector.js";
import { createOptionsList } from "./create-options-list.js";
import { pushContactLensesChangeQuantityEvent } from "../../../../../../../../../../../../../Analytics/events/modules/Analytics/events/change-quantity-events.js";
import { useContactLensProductData } from "../../../../../../../../../../../../../../context/context/product-context-hooks.js";
import { useCLEcommContext } from "../../../../../../../../../../../context/modules/EcommContent/ContactLensesEcommContent/context/CLEcommContext.js";
const CLQuantitySelectorContainer = React.memo(
  ({ eyeSideId, className, isEnabled }) => {
    const { getLabel } = useIntl();
    const { activeVariant } = useContactLensProductData();
    const { actions, state, triggerToastMessage } = useCLEcommContext();
    const { quantitySelector } = state.configurator[eyeSideId];
    const { maxSelectableQuantity, selectionInvalidatedCount } = quantitySelector;
    const { purchaseType } = state.configurations;
    const { quantity: selectedQuantity } = state.configurations[eyeSideId];
    const { lensesPerBox } = activeVariant;
    const options = createOptionsList({ maxSelectableQuantity, lensesPerBox, getLabel });
    React.useEffect(() => {
      if (!!selectionInvalidatedCount) {
        triggerToastMessage("quantity-invalidated-warning");
      }
    }, [selectionInvalidatedCount]);
    const handleQuantityChange = React.useCallback(
      (quantity) => {
        actions.updateSelectedQuantity(eyeSideId, quantity);
        pushContactLensesChangeQuantityEvent({ quantity, purchaseType, eyeSide: eyeSideId });
      },
      [actions, eyeSideId, purchaseType]
    );
    return /* @__PURE__ */ React.createElement(
      CLQuantitySelector,
      {
        className,
        parentId: eyeSideId,
        onChange: handleQuantityChange,
        selectedQuantity,
        options,
        isDisabled: !isEnabled || !maxSelectableQuantity
      }
    );
  }
);
export {
  CLQuantitySelectorContainer
};
//# sourceMappingURL=CLQuantitySelectorContainer.js.map
